import { useState } from 'react';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              多端体验
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              移动客户端
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              随时随地，精彩视频尽在掌握
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-2xl p-8 md:p-10">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-200 overflow-hidden">
                  {!imgError ? (
                    <img
                      src="https://readdy.ai/api/search-image?query=Abstract%20modern%20mobile%20interface%20mockup%20with%20warm%20coral%20and%20amber%20gradient%20elements%2C%20minimalist%20design%2C%20representing%20video%20streaming%20mobile%20app%2C%20clean%20editorial%20aesthetic%2C%20rounded%20corners%2C%20soft%20shadows&width=400&height=400&seq=app-section-visual&orientation=squarish"
                      alt="69视频移动客户端 - 随时随地看视频"
                      title="69视频-移动客户端"
                      className="w-full h-full object-cover"
                      onError={() => setImgError(true)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-foreground-300">
                      <i className="ri-smartphone-line text-4xl"></i>
                    </div>
                  )}
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-lg font-semibold text-foreground-900 mb-3 font-heading">
                    移动端优化 · 观影更自在
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                    69视频推荐的所有视频平台均支持移动端H5播放，部分平台如蜜桃视频已推出独立的移动优化版本。在手机上即可享受高清流畅的观影体验，通勤、午休、睡前，随时随地打开即看。我们建议根据所用网络环境选择合适的画质档位，平衡流畅度与清晰度。
                  </p>
                  <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                    <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-xs font-medium whitespace-nowrap border border-background-300">
                      <i className="ri-android-line"></i>
                      安卓端支持
                    </span>
                    <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-xs font-medium whitespace-nowrap border border-background-300">
                      <i className="ri-apple-line"></i>
                      iOS端支持
                    </span>
                    <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-xs font-medium whitespace-nowrap border border-background-300">
                      <i className="ri-computer-line"></i>
                      网页端通用
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}